/** Disable mouse-wheel and arrow-key increment on all number inputs. */
export function setupNumberInputGuards() {
  const isActiveNumberInput = (el) =>
    el instanceof HTMLInputElement &&
    el.type === "number" &&
    !el.disabled &&
    !el.readOnly &&
    el === document.activeElement;

  document.addEventListener(
    "wheel",
    (e) => {
      if (isActiveNumberInput(document.activeElement)) {
        e.preventDefault();
      }
    },
    { passive: false, capture: true },
  );

  document.addEventListener(
    "keydown",
    (e) => {
      if ((e.key === "ArrowUp" || e.key === "ArrowDown") && isActiveNumberInput(e.target)) {
        e.preventDefault();
      }
    },
    { capture: true },
  );
}
